import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * æ½è±¡å®ä½, ç¨æ¥å±ç¤ºä¸»é¡µä¿¡æ¯
 */
@JsonObject
export class MoreInfoData {
  /**
   * åç§°
   */
  @JsonProperty('title', String)
  title: string = undefined;

  /**
   * åå®¹
   */
  @JsonProperty('text', String)
  text: string = undefined;

  /**
   * å¾çè·¯å¾
   */
  @JsonProperty('imageUrl', String)
  imageUrl: string = undefined;

  /**
   * æé å½æ°
   */
  constructor(title?: string, text?: string, imageUrl?: string) {
    this.title = title;
    this.text = text;
    this.imageUrl = imageUrl;
  }
}
